import { UserCheckIcon, UsersIcon, type LucideIcon } from "lucide-react";
import type { MessageKey } from "@/i18n";

export const UsersSettingsTabs = {
  active: "BI accounts",
  inactive: "Foodics accounts",
} as const;
export type UsersSettingsTab = (typeof UsersSettingsTabs)[keyof typeof UsersSettingsTabs];

export const TabIcons: Record<UsersSettingsTab, LucideIcon> = {
  [UsersSettingsTabs.active]: UserCheckIcon,
  [UsersSettingsTabs.inactive]: UsersIcon,
};

export const TabLabels: Record<UsersSettingsTab, MessageKey> = {
  [UsersSettingsTabs.active]: "users.biAccounts",
  [UsersSettingsTabs.inactive]: "users.foodicsAccounts",
};
